import React, { useEffect, useState } from "react";
import axios from "axios";
import "../App.css";

export default function Invoices() {
    const [invoices, setInvoices] = useState([]);
    const [apartments, setApartments] = useState([]);
    const [formData, setFormData] = useState({
        apartment_id: "",
        employee_name: "",
        item: "",
        total: "",
        description: "",
        currency: "$",
    });
    const [file, setFile] = useState(null);

    const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:5000";
    const INVOICES_API = `${API_BASE}/api/invoices`;
    const APARTMENTS_API = `${API_BASE}/api/apartments`;

    useEffect(() => {
        fetchInvoices();
        fetchApartments();
    }, []);

    const fetchInvoices = async () => {
        try {
            const token = localStorage.getItem("token");

            const res = await axios.get(INVOICES_API, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            setInvoices(res.data);
        } catch (err) {
            console.error("Error fetching invoices:", err);
        }
    };

    const fetchApartments = async () => {
        try {
            const token = localStorage.getItem("token");

            const res = await axios.get(APARTMENTS_API, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            setApartments(res.data);
        } catch (err) {
            console.error("Error fetching apartments:", err);
        }
    };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const token = localStorage.getItem("token");
        if (!token) {
            alert("You must be logged in to add an invoice.");
            return;
        }

        try {
            const formDataToSend = new FormData();
            Object.entries(formData).forEach(([key, value]) => {
                formDataToSend.append(key, value);
            });
            if (file) formDataToSend.append("proof", file);

            await axios.post(INVOICES_API, formDataToSend, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${token}`,
                },
            });

            alert("✅ Invoice added successfully!");
            await fetchInvoices(); // refresh the list

            // reset form
            setFormData({
                apartment_id: "",
                employee_name: "",
                item: "",
                total: "",
                description: "",
                currency: "$",
            });
            setFile(null);
        } catch (err) {
            console.error("Error adding invoice:", err);
            const msg =
                err.response?.data?.message ||
                err.message ||
                "Server error while adding invoice.";
            alert(`❌ ${msg}`);
        }
    };

    const handleDelete = async (id) => {
        const token = localStorage.getItem("token");
        if (!token) {
            alert("You must be logged in to delete an invoice.");
            return;
        }

        if (!window.confirm("Are you sure you want to delete this invoice?")) return;

        try {
            await axios.delete(`${INVOICES_API}/${id}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            alert("🗑️ Invoice deleted successfully!");
            await fetchInvoices(); // refresh after delete
        } catch (err) {
            console.error("Error deleting invoice:", err);
            const msg =
                err.response?.data?.message ||
                err.message ||
                "Server error while deleting invoice.";
            alert(`❌ ${msg}`);
        }
    };

    return (
        <div className="invoice-page">
            <h2>Invoices</h2>

            {/* Add Invoice Form */}
            <form className="invoice-form glass" onSubmit={handleSubmit}>
                <label>
                    Apartment
                    <select
                        name="apartment_id"
                        value={formData.apartment_id}
                        onChange={handleChange}
                        required
                    >
                        <option value="">-- Select Apartment --</option>
                        {apartments.map((ap) => (
                            <option key={ap.id} value={ap.id}>
                                {ap.number}
                            </option>
                        ))}
                    </select>
                </label>
                <label>
                    Employee Name
                    <input type="text" name="employee_name" value={formData.employee_name} onChange={handleChange} required />
                </label>
                <label>
                    Item
                    <input type="text" name="item" value={formData.item} onChange={handleChange} required />
                </label>
                <label>
                    Total
                    <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                        <input
                            type="number"
                            name="total"
                            value={formData.total}
                            onChange={handleChange}
                            required
                            style={{ flex: 1 }}
                        />
                        <span>$</span>
                    </div>
                </label>
                <label>
                    Description
                    <textarea name="description" value={formData.description} onChange={handleChange}></textarea>
                </label>
                <label>
                    Proof (receipt photo)
                    <input type="file" onChange={handleFileChange} accept="image/*" />
                </label>
                <button type="submit" className="btn-primary">Add Invoice</button>
            </form>

            {/* Invoice Table (desktop) */}
            <div className="invoice-table glass">
                <table>
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Apartment</th>
                            <th>Employee</th>
                            <th>Item</th>
                            <th>Total</th>
                            <th>Description</th>
                            <th>Proof</th>
                            <th>Date Added</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {invoices.map((inv) => (
                            <tr key={inv.id}>
                                <td>{inv.id}</td>
                                <td>{inv.apartment_number}</td>
                                <td>{inv.employee_name}</td>
                                <td>{inv.item}</td>
                                <td>{inv.currency || "$"}
                                    {inv.total}
                                </td>
                                <td>{inv.description || "—"}</td>
                                <td>
                                    {inv.proof ? (
                                        <a
                                            href={`${API_BASE}/uploads/${inv.proof}`}
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            View
                                        </a>
                                    ) : (
                                        "—"
                                    )}
                                </td>
                                <td className="cell-nowrap">
                                    {inv.created_at
                                        ? new Date(inv.created_at).toLocaleDateString()
                                        : "—"}
                                </td>
                                <td>
                                    <button
                                        onClick={() => handleDelete(inv.id)}
                                        className="btn-danger sm"
                                    >
                                        Delete
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* Invoice Cards (mobile) */}
            <div className="invoice-cards">
                {invoices.map((inv) => (
                    <div key={inv.id} className="invoice-card">
                        <div className="row">
                            <span className="label">Apartment</span>
                            <span className="value">{inv.apartment_number}</span>
                        </div>
                        <div className="row">
                            <span className="label">Employee</span>
                            <span className="value">{inv.employee_name}</span>
                        </div>
                        <div className="row">
                            <span className="label">Item</span>
                            <span className="value">{inv.item}</span>
                        </div>
                        <div className="row">
                            <span className="label">Total</span>
                            <span className="value amount">
                                {inv.currency || "$"}
                                {inv.total}
                            </span>
                        </div>
                        <div className="row">
                            <span className="label">Description</span>
                            <span className="value">{inv.description || "—"}</span>
                        </div>
                        <div className="row">
                            <span className="label">Date</span>
                            <span className="value cell-nowrap">
                                {inv.created_at
                                    ? new Date(inv.created_at).toLocaleDateString()
                                    : "—"}
                            </span>
                        </div>
                        <div className="row">
                            <span className="label">Proof</span>
                            <span className="value">
                                {inv.proof ? (
                                    <a
                                        href={`${API_BASE}/uploads/${inv.proof}`}
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        View
                                    </a>
                                ) : (
                                    "—"
                                )}
                            </span>
                        </div>
                        <div className="actions">
                            <button
                                onClick={() => handleDelete(inv.id)}
                                className="btn-danger sm"
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
